import React from "react";
import { Star, Trophy, Sparkles, Award } from "lucide-react";

const TopPerformerCard = ({ employee }) => {
  const defaultEmployee = {
    id: 1,
    name: "Coming Soon",
    position: "Role",
    department: "Department",
    image: null,
  };

  const performerData = employee || defaultEmployee;

  return (
    <div className="w-full h-full mx-auto rounded-3xl shadow-sm">
      <div
        className="relative rounded-3xl overflow-hidden bg-blue-600 h-full"
        style={{ backgroundColor: "var(--active-color, #2563eb)" }}
      >
        {/* Enhanced top section with decorative border */}
        <div className="absolute top-0 left-0 w-full h-3 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400"></div>

        {/* Background decorative elements */}
        <div className="absolute inset-0 overflow-hidden ">
          <div className="absolute -top-20 -left-20 w-40 h-40 border-4 border-white/10 rounded-full"></div>
          <div className="absolute -bottom-20 -right-20 w-60 h-60 border-4 border-white/10 rounded-full"></div>
          <div className="absolute top-10 right-10 w-20 h-20 border-2 border-white/20 rounded-full"></div>

          <div className="absolute top-8 left-8">
            <Sparkles size={16} className="text-yellow-300 animate-pulse" />
          </div>
          <div className="absolute top-16 right-16">
            <Star
              size={12}
              className="text-yellow-200 animate-pulse"
              style={{ animationDelay: "0.5s" }}
            />
          </div>
          <div className="absolute bottom-20 left-12">
            <Star
              size={14}
              className="text-yellow-300 animate-pulse"
              style={{ animationDelay: "1s" }}
            />
          </div>
          <div className="absolute bottom-32 right-8">
            <Sparkles
              size={12}
              className="text-yellow-200 animate-pulse"
              style={{ animationDelay: "1.5s" }}
            />
          </div>
        </div>

        {/* Enhanced header section */}
        <div className="relative z-10 pt-6 pb-2">
          <div className="text-center ">
            <div className="flex items-center justify-center gap-2 ">
              <Award size={24} className="text-yellow-300" />
              <h2
                className="text-2xl font-bold tracking-wide"
                style={{ color: "var(--text-color)" }}
              >
                Congratulations!
              </h2>
              <Award size={24} className="text-yellow-300" />
            </div>
            <div
              className="inline-flex items-center gap-2 text-yellow-300 bg-white/10 rounded-full backdrop-blur-sm"
              style={{ color: "var(--text-color)" }}
            >
              <Star size={18} fill="currentColor" />
              <span className="text-base font-semibold">
                Employee of the Month
              </span>
              <Star size={18} fill="currentColor" />
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="relative z-10 px-4">
          <div className="relative mb-4">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-sm border border-white/20">
              <div className="flex items-center gap-4">
                <div className="relative">
                  <div
                    className="w-16 h-16 rounded-full flex items-center justify-center shadow-sm bg-blue-600"
                    style={{ backgroundColor: "var(--active-color, #2563eb)" }}
                  >
                    {performerData.image ? (
                      <img
                        src={performerData.image}
                        alt={performerData.name}
                        className="w-full h-full rounded-full object-cover"
                      />
                    ) : (
                      <div className="text-white text-xl font-bold">
                        {performerData.name
                          .split(" ")
                          .map((n) => n[0])
                          .join("")}
                      </div>
                    )}
                  </div>

                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center shadow-sm">
                    <Trophy size={16} className="text-yellow-800" />
                  </div>
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-800 mb-1">
                    {performerData.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-1">
                    {performerData.position}
                  </p>
                  <p className="text-xs text-gray-500">
                    {performerData.department}
                  </p>
                </div>
              </div>
            </div>

            <div className="absolute -top-3 -right-0 w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center shadow-sm border-4 border-white">
              <span className="text-lg font-bold text-yellow-800">#1</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopPerformerCard;
